import { CostView } from "./costView";
import {TranslateService} from "@ngx-translate/core";
import FormUtils from "../../components/utils/form-utils.component";

export class InfixFormula {

    constructor(public value: string, public costView: CostView, public translate: TranslateService) {
        costView.mathOperators.forEach((item) => { this.operators.push(item.value); });
        costView.conditionalOperators.forEach((item) => { this.operators.push(item.value); });
        costView.logicalOperators.forEach((item) => { this.operators.push(item.value); });
        this.initProperties();
    }

    public operators: string[] = [];
    public tokenizedExpression: string[] = [];

    public groupIndex: number;
    public nestedGroupIndex: number;
    public nestedGroupId: number;
    public insideGroup: boolean;
    public insideNestedGroup: boolean;
    public functionLevel: number;
    public functionInsideNested: boolean;
    public prevFunction: boolean;

    public cfGroups: any[][];
    public outterOperators: string[];
    public innerOperators: any[][];
    public innerFunctions: any[][];
    public nestedInnerOperators: any;
    public nestedInnerFunctions: any;

    public initProperties() {
        this.groupIndex = 0;
        this.nestedGroupIndex = 0;
        this.nestedGroupId = 0;
        this.insideGroup = false;
        this.insideNestedGroup = false;
        this.functionLevel = 0;
        this.functionInsideNested = false;
        this.prevFunction = false;

        this.cfGroups = [[]];
        this.outterOperators = [];
        this.innerOperators = [[]];
        this.innerFunctions = [[]];
        this.nestedInnerOperators = {};
        this.nestedInnerFunctions = {};
    }

    public resetDrag() {
        if (!this.value) {
            this.tokenizedExpression = [];
        } else {
            this.tokenizedExpression = this.value.split(this.costView.infixSeparator);
        }
        this.initProperties();

        this.tokenizedExpression.forEach((token, index) => {
            this.processExpressionItem(token, index);
        });
    }

    public wrapFunction(functionValue, tokenValue, tokenName, tokenNestedId = 0, prettyPrint = false) {
      console.log("wrapFunction tokenValue input", tokenValue);
      let addedExpressions = [];
      this.costView.mathFunctions.some( (func) => {
            if (func.value === functionValue) {
                let itemValue = "";
                try {
                    addedExpressions.push(prettyPrint ? FormUtils.generateGuideIdFromTitle(this.translate.instant(func.label)) : func.value);
                } catch (e) {
                    addedExpressions.push("");
                }
                addedExpressions.push("(");
                if (tokenValue && typeof tokenValue === "object") { // token is nestedGroup
                    addedExpressions.push("(");
                    tokenValue.value.forEach((item, index) => {
                        if (!isNaN(Number(item.value))) {
                            itemValue = item.value;
                        } else if (item.value.match(/^'\d{4}-\d{2}-\d{2}'/g)) {
                            itemValue = item.value;
                        } else if (item.value.match(/^\d{4}-\d{2}-\d{2}/g)) {
                            itemValue = this.costView.addIdWrapper(item.value, false, false);
                        } else {
                            itemValue = (prettyPrint && item.name !== "textValue" && item.name !== "dateToday") ? item.label : this.costView.addIdWrapper(item.value, item.name, prettyPrint);
                        }

                        if (index > 0) {
                            addedExpressions.push(this.nestedInnerOperators[tokenNestedId][index - 1]);
                        }
                        if (this.nestedInnerFunctions[tokenNestedId][index]) {
                            addedExpressions = addedExpressions.concat(
                                this.wrapFunction(this.nestedInnerFunctions[tokenNestedId][index],
                                    itemValue, item.name, null, prettyPrint));
                        } else {
                            addedExpressions.push(itemValue);
                        }
                    });
                    addedExpressions.push(")");
                } else {
                    itemValue = "";
                    if (!isNaN(Number(tokenValue))) {
                        itemValue = tokenValue;
                    } else if (tokenValue.match(/^'\d{4}-\d{2}-\d{2}'/g)) {
                        itemValue = tokenValue;
                    } else if (tokenValue.match(/^\d{4}-\d{2}-\d{2}/g)) {
                        itemValue = this.costView.addIdWrapper(tokenValue, false, false);
                    } else {
                        itemValue = (prettyPrint && tokenName !== "textValue" && tokenName !== "dateToday") ? tokenValue : this.costView.addIdWrapper(tokenValue, tokenName, prettyPrint);
                    }
                    addedExpressions.push(itemValue);
                }
                addedExpressions.push(")");
                return true;
            }
        });
      return addedExpressions;
    }

    public isFunction(token) {
        return this.costView.mathFunctions.some( (func) => {
            return func.value === token;
        });
    }

    public processExpressionItem(token, index) {
        if (this.prevFunction && token === "(") {
            this.prevFunction = false;
            return;
        }
        if (index === 0) {
            this.cfGroups = [];
            this.innerOperators = [];
            this.innerFunctions = [];
        }
        if (token === "(" && !this.insideGroup && !this.insideNestedGroup) {
            this.cfGroups.push([]);
            this.innerOperators.push([]);
            this.innerFunctions.push([]);
            this.groupIndex = this.cfGroups.length - 1;
            this.insideGroup = true;
        } else if (token === ")" && (!this.insideNestedGroup || this.functionLevel > 0)) {
            if (this.functionLevel > 0) { this.functionLevel--; } else { this.insideGroup = false; }
        } else if (this.insideGroup) {
            if (token === "(") {
                this.cfGroups[this.groupIndex].push({label: "", name: "group", value: [], type: "group", nestedId: this.nestedGroupId});
                this.nestedGroupId++;
                this.nestedGroupIndex = this.cfGroups[this.groupIndex].length - 1;
                this.insideNestedGroup = true;
            } else if (token === ")") {
        if (this.functionLevel > 0) {
          this.functionLevel--;
        } else { this.insideNestedGroup = false; }
            } else if (this.functionLevel > 0 && (token === ")" || token === "(")) {
                return;
            } else if (this.insideNestedGroup) {
                const key = this.cfGroups[this.groupIndex][this.nestedGroupIndex].nestedId;
                if (typeof this.nestedInnerOperators[key] !== "object") { this.nestedInnerOperators[key] = []; }
                if (typeof this.nestedInnerFunctions[key] !== "object") { this.nestedInnerFunctions[key] = []; }

                if (this.operators.indexOf(token) > -1) {
                    this.nestedInnerOperators[key].push(token);
                } else if (this.isFunction(token)) {
                    this.nestedInnerFunctions[key].push(token);
                    this.prevFunction = true;
                    this.functionLevel++;
                } else {
                    if (this.nestedInnerFunctions[key].length < this.nestedInnerOperators[key].length + 1) {
                        this.nestedInnerFunctions[key].push("");
                    }

                    if (!isNaN(Number(token))) {
                        this.cfGroups[this.groupIndex][this.nestedGroupIndex].value.push({label: token, name: "numericValue", value: Number(token), type: "token"});
                    } else if (token.match(/^\d{4}-\d{2}-\d{2}/g)) {
                        this.cfGroups[this.groupIndex][this.nestedGroupIndex].value.push({label: token, name: "dateValue", value: token, type: "token"});
                    } else if (token.match(/^'\d{4}-\d{2}-\d{2}'/g)) {
                        this.cfGroups[this.groupIndex][this.nestedGroupIndex].value.push({label: token.slice(1, -1), name: "dateValue", value: token.slice(1, -1), type: "token"});
                    } else if (token === 'dateToday') {
                        this.cfGroups[this.groupIndex][this.nestedGroupIndex].value.push({label: 'Today', name: "dateToday", value: 'dateToday', type: "token"});
                    } else {
                        this.cfGroups[this.groupIndex][this.nestedGroupIndex].value.push(
                            this.costView.getPropertyById(token));
                    }
                }
            } else {
                if (typeof this.innerOperators[this.groupIndex] !== "object") { this.innerOperators[this.groupIndex] = []; }
                if (typeof this.innerFunctions[this.groupIndex] !== "object") { this.innerFunctions[this.groupIndex] = []; }

                if (this.operators.indexOf(token) > -1) {
                    this.innerOperators[this.groupIndex].push(token);
                } else if (this.isFunction(token)) {
                    this.innerFunctions[this.groupIndex].push(token);
                    this.prevFunction = true;
                    this.functionLevel++;
                } else {
                    if (this.innerFunctions[this.groupIndex].length < this.innerOperators[this.groupIndex].length + 1) {
                        this.innerFunctions[this.groupIndex].push("");
                    }
                    if (!isNaN(Number(token))) {
                        this.cfGroups[this.groupIndex].push({label: token, name: "numericValue", value: Number(token), type: "token"});
                    } else if (token.match(/^\d{4}-\d{2}-\d{2}/g)) {
                        this.cfGroups[this.groupIndex].push({label: token, name: "dateValue", value: token, type: "token"});
                    } else if (token.match(/^'\d{4}-\d{2}-\d{2}'/g)) {
                        this.cfGroups[this.groupIndex].push({label: token.slice(1, -1), name: "dateValue", value: token.slice(1, -1), type: "token"});
                    } else if (token === 'dateToday') {
                      this.cfGroups[this.groupIndex].push({label: 'Today', name: "dateToday", value: 'dateToday', type: "token"});
                    } else {
                        this.cfGroups[this.groupIndex].push(this.costView.getPropertyById(token));
                    }
                }
            }
        } else {
            this.outterOperators.push(token);
        }
    }

    public toInfix(isPretty: boolean = false) {
        this.tokenizedExpression = [];
        if (this.cfGroups.length) {
            this.cfGroups.forEach((cfGroup, groupIndex) => {
                this.tokenizedExpression.push("(");
                cfGroup.forEach((token, tokenIndex) => {
                    if (token.type === "group") {
                        const tokenNestedId = token.nestedId;
                        if (tokenIndex !== 0) {
                            this.tokenizedExpression.push(this.innerOperators[groupIndex][tokenIndex - 1]);
                        }
                        if (this.innerFunctions[groupIndex][tokenIndex]) {
                            this.tokenizedExpression = this.tokenizedExpression.concat(
                                this.wrapFunction(this.innerFunctions[groupIndex][tokenIndex], token, token.name, tokenNestedId, isPretty));
                            return;
                        }
                        this.tokenizedExpression.push("(");
                        token.value.forEach((nestedToken, nestedTokenIndex) => {
                            if (nestedTokenIndex === 0) {
                                if (this.nestedInnerFunctions[tokenNestedId][nestedTokenIndex]) {
                                    this.tokenizedExpression = this.tokenizedExpression.concat(
                                        this.wrapFunction(this.nestedInnerFunctions[tokenNestedId][nestedTokenIndex],
                                          (isPretty && nestedToken.name !== "textValue") ? nestedToken.label : nestedToken.value, nestedToken.name, null, isPretty));
                                } else {
                                    this.tokenizedExpression.push((isPretty && nestedToken.name !== "textValue") ? nestedToken.label : this.costView.addIdWrapper(nestedToken.value, nestedToken.name, isPretty));
                                }
                                return;
                            }
                            this.tokenizedExpression.push(this.nestedInnerOperators[tokenNestedId][nestedTokenIndex - 1]);
                            if (this.nestedInnerFunctions[tokenNestedId][nestedTokenIndex]) {
                                this.tokenizedExpression = this.tokenizedExpression.concat(
                                    this.wrapFunction(this.nestedInnerFunctions[tokenNestedId][nestedTokenIndex],
                                      (isPretty && nestedToken.name !== "textValue") ? nestedToken.label : nestedToken.value, nestedToken.name, null, isPretty));
                                return;

                            }
                            this.tokenizedExpression.push((isPretty && nestedToken.name !== "textValue") ? nestedToken.label : this.costView.addIdWrapper(nestedToken.value, nestedToken.name, isPretty));
                        });
                        this.tokenizedExpression.push(")");
                        return;
                    }
                    if (tokenIndex === 0) {
                        if (this.innerFunctions[groupIndex][tokenIndex]) {
                            this.tokenizedExpression = this.tokenizedExpression.concat(
                                this.wrapFunction(this.innerFunctions[groupIndex][tokenIndex],
                                  (isPretty && token.name !== "textValue") ? token.label : token.value, token.name, null, isPretty));
                            return;
                        }
                        this.tokenizedExpression.push((isPretty && token.name !== "textValue") ? token.label : this.costView.addIdWrapper(token.value, token.name, isPretty));
                        return;
                    }
                    this.tokenizedExpression.push(this.innerOperators[groupIndex][tokenIndex - 1]);
                    if (this.innerFunctions[groupIndex][tokenIndex]) {
                        this.tokenizedExpression = this.tokenizedExpression.concat(
                            this.wrapFunction(this.innerFunctions[groupIndex][tokenIndex],
                              (isPretty && token.name !== "textValue") ? token.label : token.value, token.name, null, isPretty));
                        return;
                    }
                    this.tokenizedExpression.push((isPretty && token.name !== "textValue") ? token.label : this.costView.addIdWrapper(token.value, token.name, isPretty));
                });
                this.tokenizedExpression.push(")");
                if (this.outterOperators[groupIndex]) { this.tokenizedExpression.push(this.outterOperators[groupIndex]); }
            });
        }
        return this.tokenizedExpression.join(isPretty ? " " : this.costView.infixSeparator);
    }

    public prettyPrint() {
        if (!this.value || !this.value.trim()) { return ""; }
        this.tokenizedExpression = this.value.split(this.costView.infixSeparator);
        // Build formula object based on the formula array
        this.tokenizedExpression.forEach((token, index) => {
            this.processExpressionItem(token, index);
        });
        return this.toInfix(true);
    }
}
